﻿import React, { useEffect, useState } from "react";
import { logOut } from "@/features/auth/authSlice";
import { useDispatch } from "react-redux";
import { setEnvironment } from "../../features/auth/authSlice";
import ShepButton from "@/components/GenericComponents/ShepButton";
import { Typography } from "@mui/material";
import TermsConditionModal from "@/components/Login/TermsConditionModal";

////// code example for reading tenant token
////import { useSelector } from "react-redux";
////import {
////    selectTenantToken,
////} from "../../features/auth/authSlice";
////const tenantToken = useSelector(selectTenantToken);

const EnvironmentSelectionPane = ({
  tenantGroup,
  setOpenPopUp,
  openPopUp,
  userEmail,
  userDescription,
  onTermsDeclined,
  initialTermsChallenge,
}) => {
  const tenants = tenantGroup;
  const dispatch = useDispatch();
  const [isEnvBtnDisabled, setIsEnvBtnDisabled] = useState(false);
  const [termsModal, setTermsModal] = useState({
    open: false,
    termsConditionId: null,
    htmlContent: "",
  });
  const [termsAccepted, setTermsAccepted] = useState(false);

  useEffect(() => {
    if (initialTermsChallenge?.termsRequired) {
      setTermsModal({
        open: true,
        termsConditionId: initialTermsChallenge.termsConditionId,
        htmlContent: initialTermsChallenge.htmlContent,
      });
      return;
    }

    setTermsAccepted(true);
    setTermsModal({ open: false, termsConditionId: null, htmlContent: "" });
  }, [initialTermsChallenge]);

  const SelectEnvironment = async (tenant) => {
    if (!termsAccepted) {
      setTermsModal((current) => ({ ...current, open: true }));
      return;
    }

    setIsEnvBtnDisabled(true);
    try {
      await dispatch(
        setEnvironment({
          refreshToken: localStorage.getItem("refreshToken"),
          tenantToken: tenant.TenantToken,
          tenantName: tenant.Name,
        }),
      ); // SHEP-121: Have to await this request, as without tokens any calls made from the homepage would fail.

      recordHeapLogin(tenant);
    } catch {
      dispatch(logOut());
    }
    setIsEnvBtnDisabled(false);
  };

  const handleTermsAccepted = async () => {
    setTermsModal({ open: false, termsConditionId: null, htmlContent: "" });
    setTermsAccepted(true);
  };

  const handleTermsDeclined = () => {
    setTermsModal({ open: false, termsConditionId: null, htmlContent: "" });
    setTermsAccepted(false);
    setOpenPopUp?.(false);
    dispatch(logOut());

    if (typeof onTermsDeclined === "function") {
      onTermsDeclined();
    } else {
      window.location.replace("/");
    }
  };
  // Heap.io: Record login state
  const recordHeapLogin = (tenant) => {
    window.heap.clearEventProperties();
    window.heap.addEventProperties({
      "Logged In": "true",
      "Tenant Token": tenant.TenantToken,
      "Tenant Name": tenant.Name,
    });
    window.heap.track("Login - Select Tenant");
  };
  const RejectEnvironmentSelection = async () => {
    dispatch(logOut());
    setOpenPopUp?.(false);
  };
  return (
    <div className="centerContent">
      <TermsConditionModal
        open={termsModal.open}
        termsConditionId={termsModal.termsConditionId}
        htmlContent={termsModal.htmlContent}
        onAccepted={handleTermsAccepted}
        onDeclined={handleTermsDeclined}
      />
      <div>
        <Typography //SHEP-469: figure out whats overriding
          sx={{
            color: "var(--default-light) !important",
            fontSize: "64px !important",
            fontWeight: "600 !important",
            fontFamily: "mortise !important",
          }}
        >
          Welcome Back
        </Typography>
        <Typography
          sx={{
            color: "#767676 !important",
            fontSize: "24px !important",
            fontWeight: "400 !important",
            fontFamily: "mortise !important",
          }}
        >
          {userDescription ?? userEmail}
        </Typography>
        <br />
        <Typography sx={{ color: "#FFFFFF" }}>
          Select an environment to continue
        </Typography>
      </div>
      {tenants.length > 0 ? (
        tenants.map((obj) => (
          <ShepButton
            variant="primary"
            disabled={isEnvBtnDisabled || !termsAccepted}
            key={obj.TenantToken}
            style={{
              width: "100%",
              margin: "16px 0px",
              height: "57px",
              borderRadius: "10px",
              background: "white",
              color: "black",
            }}
            onClick={() => SelectEnvironment(obj)}
          >
            {obj.Name}
          </ShepButton>
        ))
      ) : (
        <p>No tenant found</p>
      )}
    </div>
  );
};

export default EnvironmentSelectionPane;
